import { render, staticRenderFns } from "./filter-candidates.vue?vue&type=template&id=4dd8e88a&scoped=true"
import script from "./filter-candidates.vue?vue&type=script&lang=js"
export * from "./filter-candidates.vue?vue&type=script&lang=js"
import style0 from "./filter-candidates.vue?vue&type=style&index=0&id=4dd8e88a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd8e88a",
  null
  
)

export default component.exports